import PropTypes from 'prop-types'
import { useCallback, useContext, useEffect } from 'react'

import { Banner } from '@loadsmart/loadsmart-ui'

import { LoadBoardContext, LOAD_BOARD_ACTIONS } from 'legacy/contexts/loadBoard'
import analytics from 'legacy/utils/analytics'

import { getBidDescription } from '../utils/getBidDescription'
import { Notification } from './Notification'

function BidRemovedNotification({ bid }) {
  const [, dispatch] = useContext(LoadBoardContext)
  const {
    load: { uuid: loadUUID, stops },
    price,
  } = bid

  const bidDescription = getBidDescription(stops, price)
  const title = `Your bid for the ${bidDescription} was removed.`

  const hideBanner = useCallback(() => {
    dispatch({ type: LOAD_BOARD_ACTIONS.REMOVE_BID, payload: loadUUID })
  }, [loadUUID, dispatch])

  const handleDismiss = useCallback(() => {
    analytics.track('Bid Removed Banner / Dismiss')
    hideBanner()
  }, [hideBanner])

  useEffect(() => {
    analytics.track('Bid Removed Banner / View')
  }, [])

  return (
    <Notification>
      <Banner title={title} variant="neutral" onClose={handleDismiss} dismissible />
    </Notification>
  )
}

BidRemovedNotification.propTypes = {
  bid: PropTypes.shape({}).isRequired,
}

export { BidRemovedNotification }
